
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/maszyny-rolnicze-sprzedaz/lokalizacja/[lokalizacja]",
      function () {
        return require("private-next-pages/maszyny-rolnicze-sprzedaz/lokalizacja/[lokalizacja]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/maszyny-rolnicze-sprzedaz/lokalizacja/[lokalizacja]"])
      });
    }
  